var map = {
	"./activity/202408tr": "./store/activity/202408tr.js",
	"./activity/202408tr.js": "./store/activity/202408tr.js",
	"./activity/cp-yes": "./store/activity/cp-yes.js",
	"./activity/cp-yes.js": "./store/activity/cp-yes.js",
	"./activity/demo": "./store/activity/demo.js",
	"./activity/demo.js": "./store/activity/demo.js",
	"./activity/family": "./store/activity/family.js",
	"./activity/family.js": "./store/activity/family.js",
	"./activity/fruit": "./store/activity/fruit.js",
	"./activity/fruit.js": "./store/activity/fruit.js",
	"./activity/kingqueen": "./store/activity/kingqueen.js",
	"./activity/kingqueen.js": "./store/activity/kingqueen.js",
	"./activity/kuwait": "./store/activity/kuwait.js",
	"./activity/kuwait.js": "./store/activity/kuwait.js",
	"./activity/ladies": "./store/activity/ladies.js",
	"./activity/ladies.js": "./store/activity/ladies.js",
	"./activity/level": "./store/activity/level.js",
	"./activity/level.js": "./store/activity/level.js",
	"./activity/lottery": "./store/activity/lottery.js",
	"./activity/lottery.js": "./store/activity/lottery.js",
	"./activity/monthly": "./store/activity/monthly.js",
	"./activity/monthly.js": "./store/activity/monthly.js",
	"./activity/national": "./store/activity/national.js",
	"./activity/national-star": "./store/activity/national-star.js",
	"./activity/national-star.js": "./store/activity/national-star.js",
	"./activity/national.js": "./store/activity/national.js",
	"./activity/nationalTemplate": "./store/activity/nationalTemplate.js",
	"./activity/nationalTemplate.js": "./store/activity/nationalTemplate.js",
	"./activity/pk": "./store/activity/pk.js",
	"./activity/pk.js": "./store/activity/pk.js",
	"./activity/ramadan": "./store/activity/ramadan.js",
	"./activity/ramadan.js": "./store/activity/ramadan.js",
	"./activity/recharge": "./store/activity/recharge.js",
	"./activity/recharge.js": "./store/activity/recharge.js",
	"./activity/ruby": "./store/activity/ruby.js",
	"./activity/ruby.js": "./store/activity/ruby.js",
	"./activity/tasks": "./store/activity/tasks.js",
	"./activity/tasks.js": "./store/activity/tasks.js",
	"./activity/week": "./store/activity/week.js",
	"./activity/week.js": "./store/activity/week.js",
	"./activity/weeklyStar": "./store/activity/weeklyStar.js",
	"./activity/weeklyStar.js": "./store/activity/weeklyStar.js",
	"./activity/welfare": "./store/activity/welfare.js",
	"./activity/welfare.js": "./store/activity/welfare.js",
	"./admin-control/agency_create": "./store/admin-control/agency_create.js",
	"./admin-control/agency_create.js": "./store/admin-control/agency_create.js",
	"./admin-control/vip": "./store/admin-control/vip.js",
	"./admin-control/vip.js": "./store/admin-control/vip.js",
	"./app/agentgold": "./store/app/agentgold.js",
	"./app/agentgold.js": "./store/app/agentgold.js",
	"./app/duid": "./store/app/duid.js",
	"./app/duid.js": "./store/app/duid.js",
	"./app/games": "./store/app/games.js",
	"./app/games.js": "./store/app/games.js",
	"./app/geshapon": "./store/app/geshapon.js",
	"./app/geshapon.js": "./store/app/geshapon.js",
	"./app/hobiHost": "./store/app/hobiHost.js",
	"./app/hobiHost.js": "./store/app/hobiHost.js",
	"./app/moment": "./store/app/moment.js",
	"./app/moment.js": "./store/app/moment.js",
	"./app/monopoly": "./store/app/monopoly.js",
	"./app/monopoly.js": "./store/app/monopoly.js",
	"./app/partyStore": "./store/app/partyStore.js",
	"./app/partyStore.js": "./store/app/partyStore.js",
	"./app/recharge": "./store/app/recharge.js",
	"./app/recharge.js": "./store/app/recharge.js",
	"./app/rechargebonus": "./store/app/rechargebonus.js",
	"./app/rechargebonus.js": "./store/app/rechargebonus.js",
	"./app/roomsupport": "./store/app/roomsupport.js",
	"./app/roomsupport-register": "./store/app/roomsupport-register.js",
	"./app/roomsupport-register.js": "./store/app/roomsupport-register.js",
	"./app/roomsupport.js": "./store/app/roomsupport.js",
	"./app/ruby": "./store/app/ruby.js",
	"./app/ruby.js": "./store/app/ruby.js",
	"./app/service": "./store/app/service.js",
	"./app/service.js": "./store/app/service.js",
	"./home": "./store/home/index.js",
	"./home/": "./store/home/index.js",
	"./home/index": "./store/home/index.js",
	"./home/index.js": "./store/home/index.js",
	"./home/pcnew": "./store/home/pcnew.js",
	"./home/pcnew.js": "./store/home/pcnew.js",
	"./ludo/main": "./store/ludo/main.js",
	"./ludo/main.js": "./store/ludo/main.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./store recursive ^\\.\\/.*$";


//////////////////
// WEBPACK FOOTER
// ./store ^\.\/.*$
// module id = ./store recursive ^\.\/.*$
// module chunks = 0